// extracted by mini-css-extract-plugin
export default {"head":"TableValuesHead_head__-Iyns","label":"TableValuesHead_label__r4yRJ"};